import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const MontoMedio2FormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Col md={12}>
        <Field name='montoMedio2'>
          {({ field }) => <Form.InputNumber {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='input-montoMedio2' />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MontoMedio2FormGroup)
